import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { Button, Icons } from 'sarsaparilla';
import TextInput from '../../../../ui-lottery/src/components/inputs/TextInput';
import { OrgOptionProps } from '../../props/organization';
import { flattenOrg } from '../../utils/organization';

import styles from './StewardSearchForm.scss';

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  orgId: PropTypes.string,
  orgOptions: PropTypes.arrayOf(OrgOptionProps),
  terms: PropTypes.string,
  searchOnChange: PropTypes.bool,
  showLabel: PropTypes.bool,
  showOrgSelect: PropTypes.bool,
  showLimitSelect: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  onInsert: PropTypes.func.isRequired
};

const defaultProps = {
  name: '',
  orgId: '',
  orgOptions: [],
  terms: '',
  searchOnChange: false,
  showLabel: true,
  showOrgSelect: true,
  showLimitSelect: false
};

export class StewardSearchForm extends PureComponent {
  constructor(props) {
    super(props);

    let orgIds = [];
    if (props.showOrgSelect && props.orgOptions.length > 0) {
      const option = props.orgOptions.find((o) => o.value === props.orgId);
      if (option) {
        orgIds = flattenOrg(option.org).map(({id}) => id);
      }
    }

    this.state = {
      orgId: this.props.orgId,
      query: {
        assetTypes: [this.props.id],
        terms: this.props.terms,
        orgIds
      }
    };

    this.setOrgId = this.setOrgId.bind(this);
    this.setTerms = this.setTerms.bind(this);
    this.setLimit = this.setLimit.bind(this);

    this.searchOnChange = debounce(this.searchOnChange.bind(this), 350);

    this.doSearch = this.doSearch.bind(this);
    this.doInsert = this.doInsert.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.orgOptions !== prevProps.orgOptions) {
      if (this.state.orgId === '' && this.props.orgOptions.length > 0) {
        this.setOrg(this.props.orgOptions[0]);
      }
    }
  }

  setTerms(terms) {
    this.setState((prevState) => ({ ...prevState, query: { ...prevState.query, terms } }), this.searchOnChange);
  }

  setOrgId(event) {
    const { value } = event.target;

    const option = this.props.orgOptions.find((o) => o.value === value);

    const orgIds = flattenOrg(option.org).map(({id}) => id);

    this.setState((prevState) => ({
      ...prevState,
      orgId: option.value,
      query: { ...prevState.query, orgIds }
    }), this.searchOnChange);
  }

  setOrg(option) {
    const orgIds = flattenOrg(option.org).map(({id}) => id);

    this.setState((prevState) => ({
      ...prevState,
      orgId: option.value,
      query: { ...prevState.query, orgIds }
    }));
  }

  setLimit(event) {
    const { value } = event.target;
    const limit = Math.min(50, Math.max(10, parseInt(value, 10)));

    this.setState((prevState) => ({ ...prevState, query: { ...prevState.query, limit } }), this.searchOnChange);
  }

  searchOnChange() {
    if (this.props.searchOnChange) {
      this.doSearch();
    }
  }

  doSearch() {
    this.props.onSearch(this.state.query);
  }

  doInsert() {
    this.props.onInsert(this.state.query);
  }

  render() {
    const { name, id, orgOptions, searchOnChange, showLabel, showLimitSelect, showOrgSelect } = this.props;
    const { orgId, query: { terms, limit } } = this.state;

    return (
      <div className={`${styles.row} ${styles['search-form']}`}>
        {showLabel && (<div className={`${styles.cell} ${styles.label} ${styles['label-width']}`}>{name}:</div>)}
        <div className={`${styles.cell} ${styles['min-width']}`}>
          <TextInput
            id={`${id}-search-terms`}
            value={terms}
            placeholder="Search Text"
            iconLeft={Icons.IconSearch}
            onChange={this.setTerms} />
        </div>
        {showOrgSelect && (
          <div className={`${styles.cell} ${styles['min-width']}`}>
            <select id={`${id}-search-org`} value={orgId} onChange={this.setOrgId}>
              {orgOptions.map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
            </select>
          </div>
        )}
        {!searchOnChange && (
          <div className={styles.cell}>
            <Button shouldFitContainer onClick={this.doSearch}>Search {name}</Button>
          </div>
        )}
        {showLimitSelect && (
          <div className={`${styles['align-right']} ${styles.cell} ${styles.biggest} ${styles['align-baseline']}`}>
            <select name="records-per-page" value={limit} className={styles['auto-width']} onChange={this.setLimit}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
            </select>
            &nbsp; records per page
          </div>
        )}

        <div className={styles.cell}>
          <Button shouldFitContainer onClick={this.doInsert}>Insert {name}</Button>
        </div>
      </div>
    );
  }
}

StewardSearchForm.propTypes = propTypes;
StewardSearchForm.defaultProps = defaultProps;
